import { parseDescribedDashboard } from '@solum/experience'

const FALLBACK_MEASURES = ['core.people_count', 'core.org_count'] as const

/** Decide whether Home has a governed final composition or its outage fallback. */
export function resolveHomeDashboard(value: unknown, requestSucceeded: boolean) {
  const described = parseDescribedDashboard(value).dashboard
  const items = requestSucceeded && described.resolved
    ? (described.items ?? []).filter((item) => !!item.source.measureKey)
    : []
  const final = items.length > 0
  return {
    state: final ? 'final' as const : 'fallback' as const,
    items,
    itemKeys: items.map((item) => item.itemKey),
    measureKeys: final
      ? items.map((item) => item.source.measureKey).filter((key): key is string => !!key)
      : [...FALLBACK_MEASURES],
  }
}
